export default __webpack_public_path__ + "static/media/cer10.0a51857b.png";